import React from "react";
import { Outlet } from "react-router-dom";
import { PeekAlert, PeekBox, PeekGrid, PeekScreenLoader, PeekSnackbar, PeekTypography, } from "@piiqtechnologies/ui-components";
import { RefetchProvider, useError, useLoader, useNotification } from "@piiqtechnologies/ui-lib";
export const AppLayout = ({}) => {
    const { loader } = useLoader();
    const { error, setError } = useError();
    const { notification, setNotification } = useNotification();
    const handleCloseAlert = (_event, reason) => {
        if (reason === "clickaway")
            return;
        setError(null);
        setNotification(null);
    };
    return (React.createElement(PeekBox, { sx: { backgroundColor: "grey.50", overflowY: "auto", display: "flex", flexDirection: "column" }, height: "100vh" },
        loader && React.createElement(PeekScreenLoader, { layered: true }),
        React.createElement(PeekGrid, { container: true, xs: 12, sx: { flex: 1 }, width: "100vw", maxWidth: "100vw !important", overflow: "auto", alignItems: "flex-start", height: "-webkit-fill-available" },
            React.createElement(RefetchProvider, null,
                React.createElement(Outlet, null))),
        React.createElement(PeekSnackbar, { anchorOrigin: { vertical: "top", horizontal: "right" }, open: !!error || !!notification, autoHideDuration: 3000, "data-testid": "app-error", onClose: handleCloseAlert },
            React.createElement(PeekBox, null,
                React.createElement(PeekAlert, { sx: { alignItems: "center" }, onClose: handleCloseAlert, severity: (error && "error") || "success" },
                    React.createElement(PeekTypography, { variant: "body1" }, error || notification))))));
};
export default AppLayout;
